export default __webpack_public_path__ + "static/media/06.ea9b0367.jpg";